import React from 'react';
import './OrderDeniedPage.scss';
import Button from 'Components/Shared/Button/Button';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import InfoContactContainer from 'Components/InfoContact/InfoContactContainer';
import { FormattedMessage, FormattedTime, FormattedDate } from 'react-intl';
import DateSpan from 'Components/Shared/DateSpan/DateSpan';

interface IProps {
  orderID: number;
  orderExpireDate: Date;
  onTryAgain: () => void;
  onCancel: () => void;
}

const OrderDeniedPage: React.SFC<IProps> = ({
  orderID,
  orderExpireDate,
  onTryAgain,
  onCancel,
}) => {

  const inlineTryAgain = (
    <span className='try-again' onClick={ onTryAgain }>
      <FormattedText 
        displayName='här'
        formattedName='order.denied.here'
      />
    </span>   
  );

  const inlineOrderID = (
    orderID &&
      <span className='order-id'>{ orderID }</span>
  );

  const inlineExpireDate = (
    orderExpireDate &&
      <span className='expire-date'>
        <FormattedDate 
          value={ orderExpireDate } 
          year='numeric' 
          month='long' 
          day='numeric' 
        />,&nbsp;
        <FormattedTime 
          value={ orderExpireDate } 
          />
      </span>
  );
  
  return (
    <div className='order-denied-page'>
      <WrapperBox>
        <FormattedText 
          style='title black'
          displayName='Misslyckad betalning'
          formattedName='order.denied.header'
        />
        <p>
          <FormattedMessage 
            id='order.denied.tryagain'
            defaultMessage={
              `Om du vill ändra leverans- eller betalningssätt, 
              välj 'Försök igen' nedan.`
            }
            values={ { tryAgainLink: inlineTryAgain } }
          />
        </p>
        <p>
          <FormattedText 
            displayName='Upplever du återkommande problem med att boka biljetter, vänligen kontakta Julius Biljettservice Callcenter.'
            formattedName='order.denied.text'
          />
        </p>
        <p>
          { orderID &&
            <FormattedMessage 
              id='order.denied.orderID'
              defaultMessage={ `Bokningsnummer: ${ orderID }` }
              values={ { orderID: inlineOrderID } }
            />
          }
          <br />
            { orderExpireDate &&
              <FormattedMessage 
                id='order.denied.expireDate'
                defaultMessage={ `Reserverad till: ${ orderExpireDate.toLocaleString() }` }
                values={ { expireDate: inlineExpireDate } }
              />
            }
        </p>
        <InfoContactContainer { ... { simplified: true } } />
      </WrapperBox>

      <div className='order-layout-footer'>
        <Button color='red' onClick={ onTryAgain }>
          <FormattedText 
            displayName='Försök igen'
            formattedName='order.button.tryagain'
          />
        </Button>
        <Button color='black' onClick={ onCancel }>
          <FormattedText 
            displayName='Avbryt'
            formattedName='order.button.cancel'
          />
        </Button>
      </div>
    </div>
  );
};

export default OrderDeniedPage;


// WEBPACK FOOTER //
// ./src/pages/OrderDeniedPage/OrderDeniedPage.tsx